import Header from '../../../Shared-Component/Header/Header';
import counc1 from "../../../assets/CampuLifeImages/counc1.jpg"
import Footer from "../../../Shared-Component/Footer/Footer"
import CampusTitle from '../../CampusSharedComponent/CampusTitles/CampusTitle/CampusTitle';
import CampusTableComponent from '../../CampusSharedComponent/CampusTableComponent/CampusTableComponent';
import CampusGrid from "../../CampusSharedComponent/CampusSections/CampusGridSection/CampusGrid"



const MentorMentee = () => {
    const tableData = [
    { title: "Mentor Mentee Members" },
    { headings: [{ heading1: "S.No.", heading2: "Name", heading3: "Designation & Department", heading4: "Position"}] },
    {
      data: [{ id: 1, name: 'Dr. V. S. Sangeetha', designDept: "Asst. Prof. & Head, Departemnt of Biotechnology (PG)", pos: "Convener" },
      { id: 2, name: 'Dr. T. Shining Vinyl Priya', designDept: "Asst. Prof. & Head, Department of Chemistry", pos: "Member"},
      { id: 3, name: 'Dr. T. O. Sunitha', designDept: "Asst. Prof., Bachelor of Computer Applications (BCA)", pos: "Member"},
      { id: 4, name: 'Dr. R. Mary Rani', designDept: "Asst. Prof., Department of Tamil", pos: "Member"},
    ]
    },
  ];
  const mentorMenteeContent = {
    name:"mentor",
    viewmore:true,
    viewless:true,
    contentImg: counc1, 
    hover:true,
    para: "After joining the course, students face pressures, which may be academic, personal, or career related. There is cross cultural, neo-ethnic convergence, increasing academic competition, mounting career demand, etc. among the students. To prevent student going through these stress factors and to help them overcome the above mentioned problems, the Faculty Mentor and Mentee system are implemented in the College where in a teacher acts as Faculty Mentor and counsellor to a group of students.",
    paratitle:"Objectives :",
    paratitlecontents:[
      {content:"To help the students to cope up academically."},
      {content:"To give personal Counselling and to extend career guidance."},
      {content:"To support co-curricular activities."},
      {content:"To co-ordinate welfare activities."},
      {content:"To interact with their parents and to seek student’s involvement in pursuit of college vision and objectives."}
    ],
    paraone:"Through these activities we aim to establish a healthy, co-operative and academic ambience in the College."
  }
  return (
    <>
      <div>
        <Header />
        <div className='campusmaincontainer'>
        <div className='campus-container'>
          <CampusTitle title="Mentor Mentee" />
          <CampusGrid content={mentorMenteeContent} />
          <CampusTableComponent tableData={tableData} />
        </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default MentorMentee